import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Story", href: "#story", testid: "nav-link-story" },
  { label: "Shop", href: "/shop", testid: "nav-link-shop" },
  { label: "Coming Soon", href: "#coming-soon", testid: "nav-link-coming-soon" },
  { label: "Instagram", href: "#instagram", testid: "nav-link-instagram" },
  { label: "Contact", href: "#contact", testid: "nav-link-contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-black/25 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 md:px-10">
        <a
          href="#top"
          data-testid="nav-wordmark"
          className="font-serif text-xs tracking-[0.22em] text-neutral-100 transition-colors duration-300 hover:text-gold-light md:text-sm"
        >
          TABI ESSENCE <span className="text-gold">OF STRENGTH</span>
        </a>
        <nav className="hidden items-center gap-10 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="text-xs uppercase tracking-[0.25em] text-neutral-400 transition-colors duration-300 hover:text-gold-light"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <a
            href="#coming-soon"
            data-testid="nav-notify-button"
            className="hidden border border-gold/40 px-5 py-2 text-[11px] uppercase tracking-[0.25em] text-gold-light transition-all duration-500 hover:bg-gold/10 hover:border-gold md:block"
          >
            Notify Me
          </a>
          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-button"
            aria-label="Open menu"
            className="text-neutral-200 transition-colors duration-300 hover:text-gold-light md:hidden"
          >
            {open ? <X className="h-6 w-6" strokeWidth={1.5} /> : <Menu className="h-6 w-6" strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border-t border-white/5 bg-black/85 backdrop-blur-xl md:hidden"
          >
            <div className="flex flex-col px-6 py-6">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-${l.testid}`}
                  className="border-b border-white/5 py-4 text-sm uppercase tracking-[0.3em] text-neutral-300 transition-colors duration-300 last:border-b-0 hover:text-gold-light"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#coming-soon"
                onClick={() => setOpen(false)}
                data-testid="mobile-nav-notify-button"
                className="mt-4 border border-gold/40 px-5 py-3 text-center text-[11px] uppercase tracking-[0.25em] text-gold-light"
              >
                Notify Me
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
